// extracted by mini-css-extract-plugin
export default {"segmentNumbersCheckPanel":"nPAflzkr7DvPlv09x65R"};